module.exports = __webpack_public_path__ + "static/media/28import-59.5ac08e19.xlsx";